import {isEmpty} from 'lodash';

let initialState = {
  data: {},
  dataDoiTuong: [],
  dataDXOld: [],
  totalDataDeXuat: []
}

function dataCuocThanhTra(state = initialState, action) {
  let newState = {
    ...state
  };
  switch (action.type) {
    case 'LOAD_DATA':
      newState.data = action.data;
      return newState;
    case 'RESET_DATA':
      newState.data = [];
      return newState;
    case 'ADD_DEXUAT':
      const dataDX = {
        idDeXuatOld: action.id,
        dataDeXuatOld: action.dataDeXuat,
        dataDeXuatsOld: action.dataDeXuats,
        hasDeXuatXuLy: action.hasDataDeXuat
      };
      if (isEmpty(newState.dataDXOld)) {
        newState.dataDXOld.push(dataDX);
      } else {
        newState.dataDXOld.forEach((item, index) => {
          if (item.idDeXuatOld === action.id) {
            newState.dataDXOld.splice(index, 1);
          }
        });
        newState.dataDXOld.push(dataDX);
      }
      return newState;
    case 'UPDATE_DEXUAT':
      const dataTemp = {
        dataDeXuat: action.dataDeXuat,
        dataDeXuats: action.dataDeXuats,
        id: action.idCTT                                                                                                 
      };
      if (isEmpty(newState.totalDataDeXuat)) {
        newState.totalDataDeXuat.push(dataTemp);
      } else {
        newState.totalDataDeXuat.forEach((item, index) => {
          if (item.id === action.idCTT) {
            newState.totalDataDeXuat.splice(index, 1);
          }
        });
        newState.totalDataDeXuat.push(dataTemp);
      }
      if (action.hasXuLy) {
        newState.hasXuLy = action.hasXuLy;
      }
      return newState;
    case 'RESET_DEXUAT':
      if (!isEmpty(newState.dataDXOld) && !isEmpty(newState.totalDataDeXuat)) {
        // Set đề xuất bằng đề xuất cũ
        const resetDeXuat = newState.totalDataDeXuat.map(item => {
          newState.dataDXOld.forEach(e => {
            if (e.idDeXuatOld === item.id) {
              return item = {
                dataDeXuat: e.dataDeXuatOld,
                dataDeXuats: e.dataDeXuatsOld,
                id: e.idDeXuatOld
              };             
            }
          });
          return item;
        });
        newState.totalDataDeXuat = resetDeXuat;
      }
      return newState;
    case 'ADD_DOITUONGID':
      const id = action.idCTT;
      const data = {
        arrDoiTuongThemMoi: action.arrDoiTuongThemMoi,
        arrDoiTuongXoa: action.arrDoiTuongXoa,
        idCTT: action.idCTT,
      };
      if (isEmpty(newState.dataDoiTuong)) {
        newState.dataDoiTuong.push(data);
      } else {
        newState.dataDoiTuong.forEach((item, index) => {
          if (item.idCTT === id) {
            newState.dataDoiTuong.splice(index, 1);
          }
        });
        newState.dataDoiTuong.push(data);
      }
      return newState;
    default:
      return newState;
  }
}

export { dataCuocThanhTra }



// WEBPACK FOOTER //
// ./src/reducers/dataCuocThanhTra.js